export default "__VITE_ASSET__DjgIF5bK__"